import {Group, Select, Stack, TextInput} from "@mantine/core";
import {SearchQuery} from "../../../api/planned/failure/PlannedFailureAPI";
import {Dispatch, SetStateAction} from "react";

export const PlannedFailureFilter = ({ query, setQuery }: { query: SearchQuery, setQuery: Dispatch<SetStateAction<SearchQuery>> }) => {
  const getSelectValue = () => {
    if (query.isDone === true) {
      return 'true'
    }

    else if (query.isDone === false) {
      return 'false'
    }

    return '';
  }

  const onSelectionChange = (value: string) => {
    if (value === 'true') {
      setQuery((_q) => ({ ..._q, isDone: true }))
    }
    else if (value === 'false') {
      setQuery((_q) => ({ ..._q, isDone: false }))
    }
    else {
      setQuery((_q) => ({ ..._q, isDone: undefined }))
    }
  }

  return (
    <Group>
      <TextInput
        value={query.q}
        onChange={e => setQuery((_q) => ({ ..._q, q: e.target.value }))}
        placeholder="Wyszukaj..."
      />

      <Select
        value={getSelectValue()}
        onChange={onSelectionChange}
        data={[
          { label: 'Wszystkie', value: '' },
          { label: 'Zakończone', value: 'true' },
          { label: 'Niezakończone', value: 'false' },
        ]}
      />
    </Group>
  );
}